export default __webpack_public_path__ + "static/media/maxine_detail4.575264cf.jpg";